"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MUTATION_REFRESH_TOKEN = exports.MUTATION_LOGIN = void 0;
exports.MUTATION_LOGIN = `
    mutation login($login: String!,$password: String!){
        auth{
            login(login:$login,password: $password){
                refreshToken
                idToken
                expiresIn
            }
        }
    }
`;
exports.MUTATION_REFRESH_TOKEN = `
    mutation refresh($refreshToken: String!){
        auth{
            refreshToken(refreshToken: $refreshToken){
                idToken
                refreshToken
                expiresIn
            }
        }
    }
`;
